/**
 * Defined in millis
 */
export const MILLIS_50 = 50;
export const MILLIS_500 = 500;
export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const MINUTES_3 = 3 * ONE_MINUTE;
export const MINUTES_5 = 5 * ONE_MINUTE;
export const MINUTES_15 = 15 * ONE_MINUTE;
export const HALF_AN_HOUR = 2 * MINUTES_15;
export const ONE_HOUR = 2 * HALF_AN_HOUR;
export const HOURS_24 = 24 * ONE_HOUR;
